import { useMutation } from "react-query";
import adminUploadDocument from "../services/adminUploadDocument";

function useAdminUploadDocument() {
  return useMutation(["admin-upload-document"], adminUploadDocument);
}

export default useAdminUploadDocument;
